<template>
  <div class="navBar">
    <div class="n_logo">
      <img src="@/assets/n_logo.png" alt="" />
    </div>
    <div class="bb1"></div>
    <div class="nav_container">
      <router-link v-for="(i, index) in navList" :key="index" :to="i.to" custom v-slot="{ navigate, href, isActive }">
        <a :href="href" @click="navigate" class="nav_list" :class="{ 'router-link-active': isActive }">
          <div class="list_icon"><img src="@/assets/svg/nicon.svg" alt="" /></div>
          <div class="list_text">{{ i.name }}</div>
        </a>
      </router-link>
    </div>
    <div class="nav_str">治粉尘·选追光</div>
    <div class="bb2"></div>
  </div>
</template>

<script>
export default {
  name: 'navBar',
  data() {
    return {
      navIndex: 0,
      navList: [
        { name: '首页', to: '/home' },
        { name: '了解追光', to: '/about' },
        { name: '应用领域', to: '/application' },
        { name: '产品中心', to: '/product' },
        { name: '新闻中心', to: '/news' },
        { name: '服务中心', to: '/service' },
        { name: '资料下载', to: '/information' },
        { name: '联系我们', to: '/contact' }
      ]
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    clickNav(row, index) {
      this.navIndex = index
      console.log(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.navBar {
  width: 244px;
  height: 760px;
  position: fixed;
  top: 110px;
  left: 156px;
  border-radius: 12px;
  background-color: rgba(0, 73, 240, 0.8);
  padding: 0 36px;
  z-index: 9999999;
  .n_logo {
    margin-top: 56px;
    width: 172px;
    height: 48px;
    img {
      width: 172px;
      height: 48px;
    }
  }
  .bb1 {
    margin-top: 56px;
    width: 20px;
    height: 4px;
    background: rgba(217, 217, 217, 1);
    border-radius: 10px;
  }
  .nav_container {
    margin-top: 28px;
    font-size: 20px;
    line-height: 28px;
    .nav_list {
      margin-bottom: 24px;
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      .list_icon {
        display: none;
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }
    a {
      display: inline-block;
      text-decoration: none;
      color: rgba(255, 255, 255, 0.9);
      font-size: 20px;
      text-align: center;
    }
    .router-link-active {
      color: rgba(255, 144, 0, 1);
      .list_icon {
        display: inline-block;
      }
    }
  }
  .nav_str {
    margin-top: 34px;
    font-size: 24px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }
  .bb2 {
    margin-top: 28px;
    width: 40px;
    height: 4px;
    border-radius: 10px;
    background: rgba(255, 144, 0, 1);
  }
}
</style>
